import { useEffect } from 'react';

const useSelectedOption = (id, options, setSelectedOption) => {
  useEffect(() => {
    if (id && options.length > 0) {
      const selected = options.find(option => option.id === id);
      if (selected) {
        setSelectedOption(selected);
      }
    }
  }, [id, options, setSelectedOption]);
};

export default useSelectedOption;
